import Loader from 'react-loader-spinner'

import './index.css'

const LoaderEl = () => (
  <div className="loader-container" data-testid="loader">
    <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
  </div>
)
export default LoaderEl
